"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

exports.StyledTextInput = styled_components_1.default(function (_a) {
  var isActive = _a.isActive,
      isError = _a.isError,
      isDisabled = _a.isDisabled,
      paddingLeft = _a.paddingLeft,
      paddingRight = _a.paddingRight,
      activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["isActive", "isError", "isDisabled", "paddingLeft", "paddingRight", "activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.TextInput, __assign({
    editable: isDisabled
  }, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (props) {
  return exports.styledTextInputStyles(props);
});

exports.styledTextInputStyles = function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      isActive = _a.isActive,
      isDisabled = _a.isDisabled,
      isError = _a.isError,
      isFilled = _a.isFilled,
      theme = _a.theme,
      paddingLeft = _a.paddingLeft,
      paddingRight = _a.paddingRight;
  return "\n    box-sizing: border-box;\n    border: 1px solid\n    border-radius: 3px;\n    padding: 8px 24px 8px 13px;\n    line-height: 28px;\n    font-family: Roboto, sans-serif;\n    font-size: 18px;\n    outline: none;\n    " + function () {
    var small = responsive_1.isSmall(activeBreakpoint);
    var colors = theme.colors,
        colorVariations = theme.colorVariations;
    return "\n            border-color: " + (isError ? colors.system.error : isActive ? colors.inputActive : colorVariations.greyscale.alpha60) + ";\n            width: " + (small ? '100%' : '340px') + ";\n            " + (paddingLeft ? "padding-left: " + paddingLeft : '') + "\n            " + (paddingRight ? "padding-right: " + paddingRight : '') + "\n            color: " + ((isFilled || isActive) && !isDisabled ? colors.title : colors.gray) + ";\n            background-color: " + (isDisabled ? colorVariations.greyscale.alpha40 : colors.white) + ";\n            box-shadow: " + (isActive ? "inset 0 1px 3px 0 " + colors.inputActiveShadow : 'none') + ";\n            pointer-events: " + (isDisabled ? 'none' : 'all') + ";\n        ";
  }() + "\n";
};

exports.default = responsive_1.withResponsiveMeta(exports.StyledTextInput);
var templateObject_1;